// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions-area {\n  flex: 0 0 55px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.selection-actions-area {\n  flex: 0 0 55px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.flex-row {\n  display: flex;\n  align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
